<template>
  <ancestryline-modal title="protocol.tab-checklist.print-letter"  id="protocol-printletter-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-text-editor v-model="finalLetter" label="forms.annotation-card.annotation"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <div class="p-ml-auto">
        <Button :label="$t('protocol.tab-checklist.print-letter')" @click="printLetter" class="p-ml-2"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalEditLetter",

  props: {
    originalLetter: {type: String, default: ""}
  },

  mounted() {
    this.finalLetter = this.originalLetter;
  },

  data(){
    return {
        finalLetter: "",
    }
  },

  methods:{
    close(){
      DialogService.closeModal();
    },
    printLetter(){
      DialogService.closeModal(this.finalLetter);
    }
  }
}
</script>